module.exports = __webpack_public_path__ + "img/Electrical fault icon 2.5e3c7f06.png";